import styled, { css } from 'styled-components';
import PagebuilderListItem, { Icon } from 'gatsby-theme-pagebuilder/src/components/blocks/list/list-item';
import Button from 'gatsby-theme-core/src/components/button';
import Content from 'gatsby-theme-core/src/components/content';

const BoksListItem = styled(PagebuilderListItem).attrs((props) => ({
  overrideContentTheme: props.variant === 'buttons' ? 'dark' : null,
}))`
  ${({ variant }) => variant === 'buttons' && css`
    padding: 0.4325rem;
    gap: 0.4325rem;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      padding: 1rem;
      gap: 0.5rem;
    }
    display: flex;
    background-color: white;
    border-radius: ${({ theme }) => theme.borderRadius};
    box-sizing: border-box;
    width: 100%;

    ${Icon} {
      flex-shrink: 0;
      height: 45px;
      width: 45px;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        height: 54px;
        width: 54px;
      }
      @supports (mask: url()) {
        background-color: ${({ theme }) => theme.primaryColor};
      }
    }

    &:hover {
      ${Icon} {
        @supports (mask: url()) {
          background-color: ${({ theme }) => theme.fontColor};
        }
      }
    }

    ${Button} {
      text-decoration: none;
      display: flex;
      align-items: center;
      flex-direction: row;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        flex-direction: column;
      }
    }

    ${Content} {
      font-size: 0.8125rem;
      font-weight: bold;
      color: ${({ theme }) => theme.fontColor};
    }
  `}
`;

export default BoksListItem;
